import useFacilityData from "../hooks/useFacilityData.ts"

export default () => {
  const data = useFacilityData()

  const facilityInfo = data.sanityFacility.facilityObj.facilityInfo

  const hasCovidLinks =
    facilityInfo.covidStatusUrl ||
    facilityInfo.dptHealthCovidGuidelinesUrl ||
    facilityInfo.covidLinks.length > 0

  const hasCovidDownloads =
    facilityInfo.returnToWorkGuidelines || facilityInfo.covidDownloads.file

  return hasCovidLinks || hasCovidDownloads
}
